import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/styles.css';

export default function navbar() {
  return (

    <div className="container">
  <nav
    className="navbar navbar-expand-lg"
    style={{ backgroundColor: "#fff" }}
    data-bs-theme="light"
  >
    <a className="navbar-brand" href="#">
      <img
        src="/images/logo.png"
        alt="Logo"
        width={128}
        height={90}
        className="d-inline-block align-text-top logo-margin"
      />
    </a>
    {/* Hamburger toggle for mobile */}
    <button
      className="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarContent"
      aria-controls="navbarContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon" />
    </button>
    {/* Navbar content */}
    <div
      className="collapse navbar-collapse justify-content-end"
      id="navbarContent"
    >
      <ul className="navbar-nav align-items-center">
        <li className="nav-item">
          <Link
            to="/"
            className="btn custom-btn custom-spacing custom-oval-btn custom-text fw-bold"
          >
            Home
          </Link>
        </li>
        <li className="nav-item dropdown custom-spacing">
          <button
            className="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold"
            type="button"
            id="APDropdownButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Andhra Pradesh
          </button>
          <ul className="dropdown-menu" aria-labelledby="APDropdownButton">
            <li>
              <Link className="dropdown-item" to="/ap/tirupati">
                Tirumala Tirupati
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ap/srisailam">
                Srisailam
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/ap/annavaram">
                Annavaram
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="/ap/simhachalam"
              >
                Simhachalam
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown custom-spacing">
          <button
            className="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold"
            type="button"
            id="MHDropdownButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Maharashtra
          </button>
          <ul className="dropdown-menu" aria-labelledby="MHDropdownButton">
            <li>
              <Link className="dropdown-item" to="/mh/shirdi">
                Shirdi Sai Sansthan
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/mh/nashik">
                Triambakeshwar Jyothirling
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/mh/pandarpur">
                Pandarpur
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/mh/kolhapur">
                Kolhapur
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown custom-spacing">
          <button
            className="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold"
            type="button"
            id="KTDropdownButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Karnataka
          </button>
          <ul className="dropdown-menu" aria-labelledby="KTDropdownButton">
            <li>
              <Link className="dropdown-item" to="/kt/dharmastala">
                Dharmastala Manjunath Shiva
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/kt/kollur">
                Kollur Mookambika Amman
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/kt/udupi">
                Udupi Sri Krishna
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/kt/kukke">
                Kukke Subramanya
              </Link>
            </li>
          </ul>
        </li>
        <li className="nav-item dropdown custom-spacing">
          <button
            className="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold"
            type="button"
            id="TMDropdownButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Tamilnadu
          </button>
          <ul className="dropdown-menu" aria-labelledby="TMDropdownButton">
            <li>
              <Link className="dropdown-item" to="/tn/arunachalam">
                Tiruvannamalai/Arunachala Shiva
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/tn/madurai">
                Madurai Meenakshi Amman
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/tn/srirangam">
                Shri Rangam
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/tn/palani">
                Palani Subramanya
              </Link>
            </li>
          </ul>
        </li>
        {/*li class="nav-item dropdown custom-spacing">
                  <button class="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold" type="button"
                      id="NIDropdownButton" data-bs-toggle="dropdown" aria-expanded="false">
                      North India
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="NIDropdownButton">
                      <li><a class="dropdown-item" href="/northindia/JK.html">Jammu & Kashmir</a></li>
                      <li><a class="dropdown-item" href="/northindia/Uttarakand.html">Uttarakand</a></li>
                      <li><a class="dropdown-item" href="/northindia/UP.html">Uttar Pradesh</a></li>
                      <li><a class="dropdown-item" href="/northindia/Rajasthan.html">Rajasthan</a></li>
                      <li><a class="dropdown-item" href="/northindia/Gujarat.html">Gujarat</a></li>
                      <li><a class="dropdown-item" href="/northindia/Odisha.html">Orissa/Odisha</a></li>
                  </ul>
              </li*/}
        <li className="nav-item dropdown custom-spacing">
          <button
            className="btn custom-btn custom-oval-btn dropdown-toggle custom-text fw-bold"
            type="button"
            id="MoreDropdownButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            More
          </button>
          <ul className="dropdown-menu" aria-labelledby="MoreDropdownButton">
            <li>
              <Link className="dropdown-item" to="/More/stotras">
                Stotras/Mantras
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                Photos
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                Songs
              </Link>
            </li>
            <li>
              <Link className="dropdown-item" to="#">
                Contact
              </Link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</div>


  )
}
